import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { StoreOutputDto, OfferService, StoreService, OfferInputDto, ItemService, ItemOutputDto, ItemInOfferDto } from 'src/generated_client';

@Component({
  selector: 'app-add-store-discount',
  templateUrl: './add-store-discount.component.html',
  styleUrls: ['./add-store-discount.component.css']
})

export class AddStoreDiscountComponent implements OnInit {

  id: any;
  isEdit: boolean = false;
  title: string = "";
  isBanner: boolean = false;
  allItems: ItemInOfferDto[] = [];
  storeId: number = 0;

  status = [
    { value: true, viewValue: 'Activo' },
    { value: false, viewValue: 'Desactivado' },
  ];

  addDiscountForm: FormGroup = this.fb.group({
    description: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    value: ['', Validators.compose([Validators.required, Validators.min(1)])],
    status: ['', Validators.required],
    image: [''],
    imageUrl: [],
    items: ['']
  });

  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private offerService: OfferService,
    private itemService: ItemService,
    private authService: AuthService,
    private router: Router,
    private snack: SnackBarService,
  ) { }

  async ngOnInit(): Promise<void> {

    this.id = this.activatedRoute.snapshot.paramMap.get("id")
    this.isEdit = (this.id != null);

    this.changeTitle();

    let store = this.authService.currentUserStore();
    this.storeId = Number(store.cdStore);

    this.itemService.apiItemGetItemsForOfferComboGet(this.storeId).subscribe(
      response => {
        this.allItems = response;
      }
    );

    if (this.isEdit) {
      await this.SetControls();
    }
  }

  async SetControls() {

    await this.offerService.apiOfferGetOneGet(this.id)
    .toPromise()
    .then(response => {
      this.addDiscountForm.controls['description'].setValue(response.dsDescription);
      this.addDiscountForm.controls['value'].setValue(response.qtValue);
      this.addDiscountForm.controls['status'].setValue(response.isEnabled);
      this.addDiscountForm.controls['imageUrl'].setValue(response.dsImageForBanner);
  
      response.itemsInOffer?.forEach(i => {
        this.allItems.push(i);
      });

      var ids = response.itemsInOffer?.map(x => x.cdItem);
      this.addDiscountForm.controls['items'].setValue(ids);
    });    
  }

  saveChanges(form: any) {

    let image;

    if (form.image.length == 0)
      image = undefined;
    else
      image = form.image._files[0]

    if (!this.isEdit) {

      this.offerService.apiOfferPostItemOfferPostForm(form.description, form.value, form.status, this.storeId, undefined, undefined, image, undefined, form.items)
        .subscribe(
          () => {
            this.router.navigate(['store-discount']);
            this.snack.openSnackBar('Los cambios se guardaron correctamente', 'Aceptar')
          },
          error => {
            this.snack.openSnackBar(error.error.error, 'Aceptar')
          }
        );

    } else {

      this.offerService.apiOfferEditItemOfferPutForm(this.id, form.description, form.value, form.status, this.storeId, undefined, undefined, image, undefined, form.items)
        .subscribe(
          () => {
            this.router.navigate(['store-discount']);
            this.snack.openSnackBar('Los cambios se guardaron correctamente', 'Aceptar')
          },
          error => {
            this.snack.openSnackBar(error.error.error, 'Aceptar')
          }
        );
    }
  }

  changeTitle() {
    if (this.isEdit)
      this.title = "EDITAR DESCUENTO";
    else
      this.title = "AGREGAR NUEVO DESCUENTO";
  }

  get ImageUrl() {
    return this.addDiscountForm.controls['imageUrl'].value;
  }
}